// Modal.js
import React, { useState } from "react";
import Select from "react-select";
import { AiOutlineClose } from "react-icons/ai";
import { useStore } from "../../store/appStore";

// Definimos aquí todos los estilos como objetos JS
const styles = {
  backdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    background: "#fff",
    borderRadius: 8,
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)",
    padding: 24,
    width: "100%",
    maxWidth: 400,
    maxHeight: "90vh",
    overflowY: "auto",
    position: "relative",
  },
  closeIcon: {
    position: "absolute",
    top: 12,
    right: 12,
    fontSize: "1.4rem",
    color: "#C59C18",
    cursor: "pointer",
    transition: "color 0.2s",
  },
  title: {
    marginTop: 0,
    marginBottom: 16,
    fontSize: "1.5rem",
    color: "#333",
    textAlign: "center",
  },
  group: {
    marginBottom: 16,
  },
  label: {
    display: "block",
    marginBottom: 4,
    fontWeight: 500,
    color: "#555",
  },
  input: {
    width: "100%",
    padding: "8px 12px",
    border: "1px solid #ccc",
    borderRadius: 4,
    fontSize: "1rem",
  },
  selectControl: {
    borderRadius: 4,
    border: "1px solid #ccc",
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 8,
    marginTop: 24,
  },
  buttonBase: {
    padding: "8px 16px",
    border: "none",
    borderRadius: 4,
    fontSize: "1rem",
    cursor: "pointer",
    transition: "background 0.2s, color 0.2s",
  },
  primary: {
    background: "#C59C18",
    color: "#fff",
  },
  primaryHover: {
    background: "#AD8E15",
  },
  disabled: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
};

export default function TempArticulo({ isOpen, onClose, onSave }) {
  const [nombre, setNombre] = useState("");
  const [precioVenta, setPrecioVenta] = useState("");
  const [selectedIva, setSelectedIva] = useState(null);
  const { tiposIvasStore } = useStore();

  if (!isOpen) return null;

  const handlePrecioChange = (e) => {
    const val = e.target.value;
    if (/^-?\d*\.?\d*$/.test(val)) setPrecioVenta(val);
  };

  const handleSave = () => {
    onSave({
      nombre,
      precioVenta: parseFloat(precioVenta),
      iva: selectedIva,
    });
    setNombre("");
    setPrecioVenta("");
    setSelectedIva(null);
    onClose();
  };

  const isDisabled = !nombre || !precioVenta || !selectedIva;

  return (
    <div style={styles.backdrop}>
      <div style={styles.modal}>
        <AiOutlineClose
          style={styles.closeIcon}
          onClick={onClose}
          onMouseOver={(e) => (e.currentTarget.style.color = "#666")}
          onMouseOut={(e) => (e.currentTarget.style.color = "#999")}
        />

        <h2 style={styles.title}>Nuevo Producto</h2>

        <div style={styles.group}>
          <label style={styles.label}>Nombre</label>
          <input
            type="text"
            style={styles.input}
            value={nombre}
            onChange={(e) => setNombre(e.target.value)}
            placeholder="p. ej. Cerveza"
          />
        </div>

        <div style={styles.group}>
          <label style={styles.label}>Precio venta</label>
          <input
            type="text"
            style={styles.input}
            value={precioVenta}
            onChange={handlePrecioChange}
            placeholder="p. ej. 150.00 o -20"
          />
        </div>

        <div style={styles.group}>
          <label style={styles.label}>IVA</label>
          <Select
            styles={{
              control: (base) => ({ ...base, ...styles.selectControl }),
            }}
            classNamePrefix="select"
            isSearchable
            options={tiposIvasStore}
            getOptionLabel={(iva) => iva.nombre}
            getOptionValue={(iva) => iva.id}
            value={selectedIva}
            onChange={setSelectedIva}
          />
        </div>

        <div style={styles.buttons}>
          <button
            style={{
              ...styles.buttonBase,
              ...styles.primary,
              ...(isDisabled ? styles.disabled : {}),
            }}
            onClick={handleSave}
            disabled={isDisabled}
            onMouseOver={(e) =>
              !isDisabled &&
              (e.currentTarget.style.background =
                styles.primaryHover.background)
            }
            onMouseOut={(e) =>
              !isDisabled &&
              (e.currentTarget.style.background = styles.primary.background)
            }
          >
            Añadir
          </button>
          <button
            style={{
              ...styles.buttonBase,
              ...styles.primary,
            }}
            onClick={onClose}
            onMouseOver={(e) =>
              (e.currentTarget.style.background =
                styles.primaryHover.background)
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.background = styles.primary.background)
            }
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}
